export default __webpack_public_path__ + "static/media/manage.7b0a8107.png";